import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IAutomaticDiscount } from './automatic-discount.model';
import { LoggerService } from '../logger/logger.service';
import { InitialConfigService } from '@core/app-config/initial-config.service';

@Injectable({
  providedIn: 'root'
})
export class AutomaticDiscountService {
  constructor(
    private http: HttpClient,
    private loggerService: LoggerService,
    private initialConfigService: InitialConfigService
  ) {}

  /**
   * Get an automatic discount by discount code
   * @param discountCode - The discount code to fetch for
   * @returns Observable of IAutomaticDiscount
   */
  getAutomaticDiscountByCode(discountCode: string): Observable<IAutomaticDiscount | undefined> {
    const baseUrl = this.initialConfigService.getBaseApiUrl();
    return this.http.get<IAutomaticDiscount>(`${baseUrl}/checkout/discount/${encodeURIComponent(discountCode)}`);
  }
}
